import ThisModule from "./SessionTypesSection";

export default ThisModule;
